module.exports = __webpack_public_path__ + "img/logo.f0a39243.jpg";